<template>
  <footer class="flex items-center py-20 px-40 bg-gray-50 border-t border-gray-300 touch:flex-col">
    <ul class="flex-shrink-0 flex items-center">
      <li
        v-for="(footerNavigationItem, index) in footerNavigation.appBadges"
        :key="`footer-navigation-badge-${index}`"
      >
        <a
          :href="footerNavigationItem.link"
          target="_blank"
        >
          <img
            :src="footerNavigationItem.image.src"
            :alt="footerNavigationItem.image.alt"
          >
        </a>
      </li>
    </ul>
    <ul class="footer-navigation-main flex flex-wrap ml-50 touch:justify-center touch:ml-0
    mobile:flex-wrap mobile:items-center">
      <li
        v-for="(footerNavigationItem, index) in footerNavigation.mainNavigation"
        :key="`footer-navigation-main-${index}`"
        class="pt-10 pb-10 touch:pt-21 mobile:px-15"
      >
        <a
          :href="footerNavigationItem.link"
          target="_blank"
          class="text-gray-500 hover:underline"
        >{{ footerNavigationItem.label }}</a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  data() {
    return Object.freeze({
      footerNavigation: {
        appBadges: [{
          image: {
            src: '/images/app-stores/play-store.svg',
            alt: 'Get it on Google Play',
          },
          link: 'https://eventor.page.link/eNh4',
        }, {
          image: {
            src: '/images/app-stores/app-store.svg',
            alt: 'Get it on the App Store',
          },
          link: 'https://eventor.page.link/mBKw',
        }],
        mainNavigation: [{
          label: 'Help center',
          link: 'https://help.eventor.app/',
        }, {
          label: 'Terms & Conditions',
          link: 'https://eventor.app/terms-of-service/',
        }, {
          label: 'Privacy Policy',
          link: 'https://eventor.app/privacy-policy/',
        }],
      },
    });
  },
};
</script>

<style scoped>
@screen tablet {
  .footer-navigation-main li:not(:last-child) {
    @apply mr-40;
  }
}
</style>
